<app-custom-select [iconClass]="'text-indent-left fw-bold'" [options]="importersList" [(ngModel)]="localValue"
  [title]="title" (ngModelChange)="onValueChange($event)" [isDisabled]="isDisabled" [createNewText]="'Add New Importer'"
  (onClickCreateNew)="createNewImporter()"></app-custom-select>
